import React from "react";
import { Box, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import awardsBUttons from "../../../assets/images/rewards/awards_button.png";
import { useTranslation } from "react-i18next";

//Componente que monta a mensagem do modal de conquistas
const MessageAchievements = ({ medalContent, handleNavigate }) => {
  const { t } = useTranslation();
  return (
    <Box
      id="message"
      sx={{
        display: "block",
        transform: "scale(0, 0)",
        transition: "all 1s ease",
        background: "#662D91",
        color: "#fff",
        fontFamily: "Montserrat",
        fontSize: "16px",
        width: "100%",
        maxWidth: "600px",
        borderRadius: "10px",
        border: "10px solid #fff",
        textAlign: "center",
        padding: "20px",
        margin: "-10% auto 0 auto",

        // Media query mobile
        "@media (max-width: 767px)": {
          position: "relative",
        },

        // Media query desktop
        "@media (min-width: 768px)": {
          position: "fixed",
          bottom: 0,
          left: 0,
          width: "100%",
          maxWidth: "100%",
          display: "flex",
          justifyContent: "space-evenly",
        },

        "& b": {
          textTransform: "uppercase",
          fontSize: "22px",
          display: "table",
          margin: "6px auto 0 auto",
        },

        "& hr": {
          borderTop: "1px solid #fff",
          borderBottom: "none",
          margin: "10px 0",
        },

        "& a": {
          display: "table",
          cursor: "pointer",
          margin: "20px auto 0 auto",
          width: "100%",
          maxWidth: "300px",
          height: "60px",
          lineHeight: "22px",
          padding: "6px 10px 0 60px",
          backgroundImage: `url(${awardsBUttons})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "100% 100%",
          color: "#fff",
          textDecoration: "none",
          textTransform: "uppercase",
          textAlign: "left",
          fontWeight: 700,
          transition: "all 0.5s ease",

          // mobile font-size
          "@media (max-width: 767px)": {
            fontSize: "12px",
          },

          // desktop font-size
          "@media (min-width: 768px)": {
            fontSize: "18px",
          },

          "&:hover": {
            transform: "scale(1.05)",
          },

          "& span": {
            width: "100%",
            display: "block",
            fontSize: "12px",
            fontWeight: 200,
          },
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        <Typography>
          {t("achievements.congratulations_you_won_the_medal")}
        </Typography>
        <b>{medalContent.title}</b>
      </Box>

      <hr />

      <Box>
        <Typography>
          {t(
            "achievements.take_this_opportunity_to_learn_about_your_achievements_and_goals"
          )}
        </Typography>

        <Link
          onClick={() => handleNavigate(medalContent.medal_id)}
          style={{ textDecoration: "none" }}
        >
          <span style={{ fontWeight: 400 }}>{t("achievements.access")}</span>{" "}
          {t("achievements.my_achievements")}
        </Link>
      </Box>
    </Box>
  );
};

export default MessageAchievements;
